/* Size guide dialog: reliable closing, and the Buy now control.

   Kept in an asset rather than inline, for the same reason as the stylesheet
   beside it.

   Closing was delegated from document in the bubble phase only, so anything
   higher up that stopped the event took the only way out with it, and there was
   no fallback if close() was refused. Both the X and Escape are bound here in
   the capture phase, which runs first and cannot be blocked by a later listener.

   Buy now closes the guide and returns the shopper to whichever purchase area is
   actually on screen. It is navigation only: it reads no form, no variant and no
   quantity, it submits nothing, and it invents no checkout. */

(function () {
  if (window.pproSizeGuideCloseHardened) { return; }
  window.pproSizeGuideCloseHardened = true;

  function shut(dialog) {
    if (!dialog) { return; }
    try { if (typeof dialog.close === 'function') { dialog.close(); return; } } catch (e) {}
    dialog.removeAttribute('open');
    dialog.dispatchEvent(new Event('close'));
  }

  /* Capture phase: runs before anything that might stop the event. */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') { return; }
    var closer = t.closest('[data-ppro-sg-close]');
    if (!closer) { return; }
    shut(closer.closest('dialog.ppro-sg') || document.querySelector('dialog.ppro-sg[open]'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) { return; }
    shut(document.querySelector('dialog.ppro-sg[open]'));
  }, true);

  /* Buy now: close, then put the shopper back on whichever purchase area is
     actually on the page. Scrolling only. */
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || typeof t.closest !== 'function') { return; }
    if (!t.closest('[data-ppro-sg-buy]')) { return; }
    setTimeout(function () {
      var order = ['.product__cart-functions', 'product-variants', '[data-js-product-add-to-cart]'];
      for (var i = 0; i < order.length; i++) {
        var el = document.querySelector(order[i]);
        if (!el) { continue; }
        var box = el.getBoundingClientRect();
        if (box.width === 0 || box.height === 0) { continue; }
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }, 80);
  });
})();
